<script>
  import Photos from "./Photos.svelte";
  import { __ } from '../utils/i18n';

</script>

<div class="note">
  <Photos
    lookup='squiggle_3'
    className = "squiggle"
    idName = ""
    ariaHidden = "false"
    lazyLoad = "false"
    />
  <h3>{__('Livestream the board meeting')}</h3>
  <p>
    {@html __("The supervisors meet every Tuesday morning.<a href='https://bos.lacounty.gov/board-meeting-agendas/'>Go here</a> to watch the live broadcast, check what's on the agenda or make a public comment.")}
  </p>
</div>